import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React from 'react';
import formatNum from '../../../../utils/helpers';

export default function Details({ data }) {
	const { type, GLA, GRI, wault, vacancy } = data;
	return (
		<ExpansionPanel defaultExpanded={true}>
			<ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
				<Typography variant="h6">
					<strong>Asset Details</strong>
				</Typography>
			</ExpansionPanelSummary>
			<ExpansionPanelDetails>
				<TableContainer>
					<Table aria-label="simple table">
						<TableBody>
							<TableRow>
								<TableCell align="left">
									<strong>Type</strong>
								</TableCell>
								<TableCell align="right">{type}</TableCell>
							</TableRow>
							<TableRow>
								<TableCell align="left">
									<strong>GLA (sqm)</strong>
								</TableCell>
								<TableCell align="right">{GLA.toLocaleString()} sqm</TableCell>
							</TableRow>
							<TableRow>
								<TableCell align="left">
									<strong>GRI</strong>
								</TableCell>
								<TableCell align="right">£{formatNum(GRI.gbp)}</TableCell>
							</TableRow>
							<TableRow>
								<TableCell align="left">
									<strong>WAULT</strong>
								</TableCell>
								<TableCell align="right">{wault} y</TableCell>
							</TableRow>
							<TableRow>
								<TableCell align="left">
									<strong>Vacancy</strong>
								</TableCell>
								<TableCell align="right">{vacancy}%</TableCell>
							</TableRow>
						</TableBody>
					</Table>
				</TableContainer>
			</ExpansionPanelDetails>
		</ExpansionPanel>
	);
}
